module.exports = __webpack_public_path__ + "img/FI09854694.b4044504.svg";